import { useSimilarDesignsContext } from '@app/pages/i/utils/SimilarDesignsContext';
import { CartItemsTray, CartItemsTrayProps } from './CartItemsTray';

/**
 * CartItemsTray wrapper that includes Similar Designs section
 * Requires a SimilarDesignsProvider and CurrentInventoryStoreProvider.
 * Use the base CartItemsTray component when you don't need similar designs.
 */
export const CartItemsTrayWithSimilarDesigns: React.FC<
  Omit<CartItemsTrayProps, 'similarDesignsData' | 'similarDesignsLoading'>
> = ({ open, onCloseRequested }) => {
  const { similarDesignsData, similarDesignsLoading } =
    useSimilarDesignsContext();

  return (
    <CartItemsTray
      open={open}
      onCloseRequested={onCloseRequested}
      similarDesignsData={similarDesignsData.similarDesigns}
      similarDesignsLoading={similarDesignsLoading}
    />
  );
};
